const ADVANCED_FILTERS_PARAM = "advancedFilters";

export interface ViewTabLink {
  key: string;
  href: string;
  /** Other paths that show this tab's table, such as the type's index. */
  aliases?: readonly string[];
}

function normalizePath(path: string): string {
  const decoded = decodeURIComponent(path);
  return decoded.length > 1 ? decoded.replace(/\/+$/, "") : decoded;
}

function parseHref(href: string): { path: string; filters: string | null } {
  const url = new URL(href, "http://record-view-tab.invalid");
  return {
    path: normalizePath(url.pathname),
    filters: url.searchParams.get(ADVANCED_FILTERS_PARAM),
  };
}

/**
 * The tab whose table and filters the location shows, else that table's tab
 * without filters; none on pages that aren't a tab's table.
 */
export function selectedViewTab<T extends ViewTabLink>(
  tabs: readonly T[],
  pathname: string,
  search: string,
): T | undefined {
  const path = normalizePath(pathname);
  const filters = new URLSearchParams(search).get(ADVANCED_FILTERS_PARAM);
  const onThisTable = tabs.flatMap((tab) => {
    const link = parseHref(tab.href);
    const paths = [link.path, ...(tab.aliases ?? []).map(normalizePath)];
    return paths.includes(path) ? [{ tab, filters: link.filters }] : [];
  });
  return (
    onThisTable.find((candidate) => candidate.filters === filters)?.tab ??
    onThisTable.find((candidate) => candidate.filters === null)?.tab
  );
}
